import React from 'react';
import './ConfirmationDialog.css'; // you can also use styled-components or Tailwind if preferred

const ConfirmationDialog = ({
  visible,
  name,
  description,
  onCancel,
  onConfirm,
  loading,
  confirmButtonLabel = 'Confirm',
}) => {
  if (!visible) return null;

  return (
    <div className="dialog-container">
      <div className="dialog-box">
        <div className="dialog-content">
          <p className="dialog-description">{description}</p>
        </div>

        <div className="dialog-actions">
          <button className="dialog-button cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="dialog-button confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
